/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LoadableContext", {
    enumerable: true,
    get: function() {
        return LoadableContext;
    }
});
const _interop_require_default = require("@swc/helpers/_/_interop_require_default");
const _react = /*#__PURE__*/ _interop_require_default._(require("react"));
const LoadableContext = _react.default.createContext(null);
if ("production" !== 'production') {
    LoadableContext.displayName = 'LoadableContext';
}
